import React, {useState,useEffect} from "react";
import { useLocation, useNavigate } from 'react-router-dom'
import LoginForm from "../../components/ManageMembershipComponents/LoginForm";
import ManageSideBar from "../../components/ManageMembershipComponents/ManageSideBar";
import MobileSteps from "../../components/MobileSteps";

export default function Login(){

        const navigate = useNavigate();
        const location = useLocation();

    document.title = 'Get a Handicap - Member Portal Login';
    let screensize = window.innerWidth;
    
 

    return ( <>
            <div className="container App_container">
            <div className="row col-10 mx-auto">
       {screensize > 992 ? 
       <>
            <div className="col-12 col-sm-5 col-md-3 col-lg-3 col-xl-3 col-xxl-3" id="navigation_container">
                <ManageSideBar />
            </div>
            <div className="col-12 col-sm-12 col-md-12 col-lg-9 col-xl-9 col-xxl-9" id="navigation_container">
                <LoginForm />
            </div>
        </> : '' }
        </div>
        {screensize <= 1024 ?
        <> 
       
        <div className="col-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12" id="navigation_mobile_container" >
            <LoginForm />
        </div>
        </>
            :''}
        
      
    </div>
          
        </>
    )
}